import { createReducer } from '@reduxjs/toolkit';

export const RECEIVE_ITEM = (state, action) => {
  if (action.payload && action.payload.id) {
    state.byId[action.payload.id] = action.payload;
  }
};

export const CLOSE_ITEM = (state, action) => {
  if (action.payload && action.payload.id) {
    delete state.byId[action.payload.id];
  }
};

export const SET_IS_BUSY = (state, action) => {
  if (!state.byId[action.payload.id]) {
    //todo: move this somewhere
    state.byId[action.payload.id] = {
      id: action.payload.id
    };
  }
  state.byId[action.payload.id].isBusy = action.payload.isBusy;
};

export const SET_HAS_VALIDATION_ERROR = (state, action) => {
  if (state.byId[action.payload.id]) {
    state.byId[action.payload.id].hasValidationError =
      action.payload.hasValidationError;
  }
};

const initialState = {
  byId: {}
};

const itemReducer = (
  receiveItemAction,
  setIsBusyAction,
  modifyItemAction,
  closeItemAction,
  onModifyAction,
  setValidationErrorAction
) =>
  createReducer(initialState, builder => {
    builder
      .addCase(receiveItemAction, RECEIVE_ITEM)
      .addCase(setIsBusyAction, SET_IS_BUSY)
      .addCase(closeItemAction, CLOSE_ITEM);

    if (setValidationErrorAction) {
      builder.addCase(setValidationErrorAction, SET_HAS_VALIDATION_ERROR);
    }

    builder.addCase(modifyItemAction, (state, action) => {
      //after saving an item, going from a new-112312 id to an actual id
      if (action.payload.newProperties.id && action.payload.id) {
        state.byId[action.payload.id].isDirty = false;
        state.byId[action.payload.newProperties.id] =
          state.byId[action.payload.id];
        state.byId[action.payload.newProperties.id].id =
          action.payload.newProperties.id;
        Object.assign(
          state.byId[action.payload.newProperties.id],
          action.payload.newProperties
        );
      } else {
        Object.assign(
          state.byId[action.payload.id],
          action.payload.newProperties
        );
        // markDirty: false is for changes already persisted server-side (not user edits)
        if (action.payload.markDirty !== false) {
          state.byId[action.payload.id].isDirty = true;
        }
        if (typeof onModifyAction === 'function') {
          onModifyAction(state, action);
        }
      }
    });
  });

export default itemReducer;
